<template>
  <div class="navigation-menu" :class="{ 'is-collapsed': collapsed }">
    <!-- Logo和折叠按钮 -->
    <div class="navigation-menu__header">
      <div class="navigation-menu__logo">
        <slot name="logo">
          <div class="logo-icon">LMIS</div>
        </slot>
        <span v-if="!collapsed" class="logo-text">{{ logoText }}</span>
      </div>
      <el-button
        type="text"
        icon="el-icon-menu"
        class="collapse-btn"
        @click="toggleCollapse"
      />
    </div>

    <!-- 搜索框 -->
    <div v-if="!collapsed" class="navigation-menu__search">
      <el-input
        v-model="searchValue"
        :placeholder="searchPlaceholder"
        prefix-icon="el-icon-search"
        size="small"
      />
    </div>

    <!-- 菜单项（可滚动区域） -->
    <el-menu
      ref="menu"
      :default-active="activeMenuId"
      :collapse="collapsed"
      :unique-opened="true"
      class="navigation-menu__menu"
      @select="handleMenuSelect"
    >
      <navigation-menu-item
        v-for="item in filteredMenuItems"
        :key="item.id"
        :item="item"
        :level="0"
        :collapsed="collapsed"
        :selected-id="selectedId"
      />
    </el-menu>

    <!-- 用户信息（固定在底部） -->
    <div v-if="!collapsed && userInfo" class="navigation-menu__footer">
      <el-dropdown @command="handleUserCommand">
        <div class="user-info">
          <el-avatar :size="24" :src="userInfo.avatar">
            {{ userInfo.name ? userInfo.name[0] : 'A' }}
          </el-avatar>
          <span class="user-name">{{ userInfo.name || 'Admin' }}</span>
          <i class="el-icon-arrow-down"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="command in userInfo.commands"
            :key="command.value"
            :command="command.value"
          >
            {{ command.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import NavigationMenuItem from './NavigationMenuItem.vue'

export default {
  name: 'NavigationMenu',
  components: {
    NavigationMenuItem
  },
  props: {
    menuItems: {
      type: Array,
      required: true
    },
    selectedId: {
      type: String,
      default: ''
    },
    logoText: {
      type: String,
      default: 'WMS'
    },
    searchPlaceholder: {
      type: String,
      default: '搜索导航名称'
    },
    userInfo: {
      type: Object,
      default: null
    },
    defaultCollapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      collapsed: this.defaultCollapsed,
      searchValue: '',
      activeMenuId: ''
    }
  },
  computed: {
    filteredMenuItems() {
      if (!this.searchValue.trim()) {
        return this.menuItems
      }
      return this.filterItems(this.menuItems, this.searchValue.toLowerCase())
    }
  },
  watch: {
    selectedId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          // 查找选中项的路径，自动展开父级
          const path = this.findMenuPath(this.menuItems, newVal)
          if (path && path.length > 0) {
            // 设置activeMenuId以展开父级菜单
            this.activeMenuId = newVal
            // 触发父级展开（通过el-menu的open方法）
            this.$nextTick(() => {
              const parentIds = path.slice(0, -1)
              parentIds.forEach(id => {
                if (this.$refs.menu) {
                  this.$refs.menu.open(id)
                }
              })
            })
          }
        }
      }
    }
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed
      this.$emit('collapse-change', this.collapsed)
    },
    handleMenuSelect(index) {
      this.activeMenuId = index
      const item = this.findMenuItem(this.menuItems, index)
      if (item && !item.children) {
        this.$emit('select', item)
      }
    },
    filterItems(items, keyword) {
      return items
        .map(item => {
          const matches = item.label.toLowerCase().includes(keyword)
          const filteredChildren = item.children
            ? this.filterItems(item.children, keyword)
            : []
          const hasMatchingChildren = filteredChildren.length > 0

          if (matches || hasMatchingChildren) {
            return {
              ...item,
              children: filteredChildren
            }
          }
          return null
        })
        .filter(Boolean)
    },
    findMenuItem(items, id) {
      for (const item of items) {
        if (item.id === id) {
          return item
        }
        if (item.children) {
          const found = this.findMenuItem(item.children, id)
          if (found) return found
        }
      }
      return null
    },
    findMenuPath(items, targetId, path = []) {
      for (const item of items) {
        const currentPath = [...path, item.id]
        if (item.id === targetId) {
          return currentPath
        }
        if (item.children) {
          const result = this.findMenuPath(item.children, targetId, currentPath)
          if (result) return result
        }
      }
      return null
    },
    handleUserCommand(command) {
      this.$emit('user-command', command)
    }
  }
}
</script>



